import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import GenericModal from "../common/GenericModal";
import PodiumLogoutForm from "./PodiumLogoutForm";

interface IParams {
  className?: string;
  isPreview:boolean;
}

const PodiumLogoutButton: React.FC<IParams> = ({ className,isPreview }) => {
  const [isModalOpen, setisModalOpen] = useState(false);
  const [t] = useTranslation(["translation", "features"], translationHookOptions);
  return (
    <>
      <div className={className}>
        <Button
          color=""
          className="podium-generic-btn"
          
          onClick={() => setisModalOpen(true)}
        >
          <i className="fas fa-2x fa-sign-out-alt"></i>
          {t("btn_logout_podium", { ns: "features" })}
        </Button>
      </div>
      {isModalOpen && isPreview===false && (
        <GenericModal
          isOpen={isModalOpen}
          toggle={() => setisModalOpen(false)}
          content={<PodiumLogoutForm />}
          size="md"
          title=" "
        />
      )}
    </>
  );
};

export default observer(PodiumLogoutButton);
